export const setCodTipoUsrLogado = (codTipoUsr: string | undefined): void => {
  sessionStorage.setItem('codTipoUsrLogado', codTipoUsr || '');
}

export const getCodTipoUsrLogado = (): string => {
  let codTipoUsr = sessionStorage.getItem('codTipoUsrLogado');
  return codTipoUsr || '';
}